export default class MathHelper {

  static isNumeric(mixed_var) {
    return (typeof(mixed_var) === 'number' || typeof(mixed_var) === 'string') && mixed_var !== '' && !isNaN(mixed_var);
  }

  static isNumberFloat(n) {
    return this.isNumeric(n) && n % 1 !== 0;
  }
  static deg2rad(angle) {
    return  (angle * Math.PI) / 180;
  }

}